import * as React from "react";
import Text from "../text";

interface IProps {
  value: string;
  id: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
}

const Password = ({
  id,
  value,
  placeholder,
  error,
  required = false,
  onChange,
  onBlur,
}: IProps) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <div
        className={`flex flex-1 h-[45px] relative border border-grey3 rounded-md overflow-hidden  ${
          error && "!border-red"
        }`}
      >
        <input
          id={id}
          name={id}
          onBlur={onBlur}
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={(e) => {
            if (onChange) onChange(e.target.value);
          }}
          className={`appearance-none block w-full px-3 py-2 border border-grey3  !border-none`}
        />
        <span
          onClick={toggleShowPassword}
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-10 font-semibold text-black/40"
        >
          {showPassword ? "HIDE" : "SHOW"}
        </span>
      </div>
      {error && (
        <Text size={11} color="red" className="mt-2" leading={1.3}>
          {error}
        </Text>
      )}
    </div>
  );
};

export default Password;
